import { Card, Popover } from 'antd'
import { CommentOutlined } from '@ant-design/icons'
import { useCallback, useState } from 'react'
import {
	ButtonCommon,
	ListPageIntro,
	ListPageShell,
	ListPageTotal,
	ModalCommon,
	PagedResourceList,
} from '../../common'
import ActionCommon from '../../common/ActionCommon/ActionCommon'
import { ReplyListCommon } from '../../common/RepliesListCommon/ReplyListCommon'
import ShowOrHideAction from '../../common/ShowOrHideAction/ShowOrHideAction'
import { useAppDispatch, useAppSelector } from '../../hooks'
import {
	onGetFeedbacks,
	onSelectFeedbacks,
} from '../../redux/feedback/feedback.action'
import { formatReportSource } from '../../utils/feedback.utils'
import './FeedbackList.scss'

import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'

export const FeedbackList = () => {
	const dispatch = useAppDispatch()
	const feedback = useAppSelector(state => state.feedback)

	const [modalVisible, setModalVisible] = useState(false)
	const [isReloadLoading, setIsReloadLoading] = useState()

	const fetchPage = useCallback(
		(page, cb) => dispatch(onGetFeedbacks(page, cb)),
		[dispatch]
	)

	const onEditClick = record => {
		dispatch(onSelectFeedbacks(record))
		setModalVisible(true)
	}

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'id',
			width: 64,
		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email',
		},
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Content',
			dataIndex: 'content',
			key: 'content',
			render: content => (
				<div className="content-info">
					{content && <div className="content-title">{content}</div>}
				</div>
			),
		},
		{
			title: 'Rating',
			dataIndex: 'rating',
			key: 'rating',
			width: 88,
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
			width: 120,
			// eslint-disable-next-line react/display-name
			render: (status, record) => (
				<ShowOrHideAction status={status} record={record} />
			),
		},
		{
			title: 'Source',
			dataIndex: 'createdBy',
			key: 'createdBy',
			render: data => formatReportSource(data),
		},
		{
			title: 'Is Replied',
			dataIndex: 'replies',
			key: 'replies',
			width: 88,
			align: 'center',
			render: data => {
				if (data && data.length >= 1) {
					return (
						<div className="feedback-is-replied">
							<CheckCircleOutlined />
						</div>
					)
				}
				return (
					<div className="feedback-is-replied">
						<CloseCircleOutlined />
					</div>
				)
			},
		},
		{
			title: 'More info',
			dataIndex: 'moreInfo',
			key: 'moreInfo',
			width: 96,
			align: 'center',
			render: data => (
				<div className="feedback-more-info">
					{data && Object.keys(data).length > 0 ? (
						<Popover content={JSON.stringify(data || '', null, 4)}>
							<div>More info</div>
						</Popover>
					) : (
						<div className="empty">(Empty)</div>
					)}
				</div>
			),
		},
		{
			title: 'Action',
			dataIndex: 'action',
			key: 'action',
			width: 100,
			align: 'center',
			// eslint-disable-next-line react/display-name
			render: (_, record) => {
				return (
					<ActionCommon onEditClick={onEditClick} record={record} />
				)
			},
		},
	]

	const handleReload = () => {
		setIsReloadLoading(true)
		dispatch(
			onGetFeedbacks(0, () => {
				setIsReloadLoading(false)
			})
		)
	}

	const getRowKey = record => {
		return record.id
	}
	const handleModalCancel = () => {
		setModalVisible(false)
	}

	const topLeft = (
		<ListPageIntro
			icon={CommentOutlined}
			title="Feedback"
			subtitle="User feedback messages from the app. Reload to refresh the list after changes."
		>
			<Card className="list-page-toolbar-card" size="small" bordered>
				<ButtonCommon
					onClick={handleReload}
					loading={isReloadLoading}
					type="primary"
				>
					Reload
				</ButtonCommon>
			</Card>
		</ListPageIntro>
	)

	return (
		<>
			<ListPageShell>
				<PagedResourceList
					resource={feedback}
					columns={columns}
					fetchPage={fetchPage}
					rowKey={getRowKey}
					headerClassName="list-page-bar"
					topLeft={topLeft}
					topRight={<ListPageTotal total={feedback?.total} />}
					tableProps={{ className: 'table-common--fluid' }}
				/>
			</ListPageShell>
			<ModalCommon
				visible={modalVisible}
				handleCancel={handleModalCancel}
				width={'80%'}
			>
				<ReplyListCommon setModalVisible={setModalVisible} />
			</ModalCommon>
		</>
	)
}
